import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import * as moment from 'moment';

@Component({
  selector: 'ba-custom-calendar',
  templateUrl: './new-range-selector.component.html'
})

export class NewRangeSelectorComponent implements OnInit {
  calendarLocale: any = {};
  selectedRange: any = {};
  dateFormat = '';
  ranges: any = {
    'Today': [moment().toDate(), moment().toDate()],
    'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
    'This Week': [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
    'Last Week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
    'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
    'Last Month': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()],
    'Last 90 days': [moment().subtract(3, 'month').toDate(), moment().toDate()],
    'Last 6 Months': [moment().subtract(6, 'month').toDate(), moment().toDate()],
    'This Year': [moment().startOf('year').toDate(), moment().toDate()],
    'Last Year': [moment().subtract(1, 'year').toDate(), moment().toDate()],
  };

  @Input('dateList') public selectedDateRange: any;
  @Output() selectedDate = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
    const isUsWeek = localStorage.getItem('companyUsWeek') ? JSON.parse(localStorage.getItem('companyUsWeek')) : false;
    this.calendarLocale = {
      format: 'MM/DD/YYYY', showCancel: true, cancelLabel: 'Cancel',
      firstDay: isUsWeek ? 0 : 1
    };
     if(!isUsWeek) {
     this.ranges['This Week'] = [moment().startOf('isoWeek'), moment().endOf('isoWeek')];
     this.ranges['Last Week'] = [moment().subtract(1, 'week').startOf('isoWeek').toDate(), moment().subtract(1, 'week').endOf('isoWeek').toDate()];
    }
    if (this.selectedDateRange && this.selectedDateRange.length) {
      this.selectedRange = { startDate: new Date(this.selectedDateRange[0]), endDate: new Date(this.selectedDateRange[1]) };
    }
    this.changedValue(this.selectedRange);
  }

  changedValue(e) {
    let arr = [];
    arr = [e.startDate, e.endDate];
    if (arr[0] && arr[1]) {
      this.selectedDate.emit(arr);
    }
  }
}
